import axios from 'axios';
import { userResponses } from './statemachine';

const API_KEY =
    process.env.REACT_APP_GOOGLE_SPEECH_API_KEY ||
    'AIzaSyAowtpKTpw7F232tvI-_rtGLfu7T95Jlb8';

if (!API_KEY) {
    console.error('Missing REACT_APP_GOOGLE_SPEECH_API_KEY');
}

export function speechToText(audioBinary) {
    const request = {
        config: {
            languageCode: 'en-AU',
        },
        audio: {
            content: audioBinary,
        },
    };

    const apiKey = API_KEY;
    const url = `https://speech.googleapis.com/v1/speech:recognize?key=${apiKey}`;

    return new Promise(function(resolve, reject) {
        axios
            .request({
                url,
                method: 'POST',
                data: request,
            })
            .then(response => {
                const userAnswer = userAnswerFromApiResponse(response);
                resolve(userAnswer);
            })
            .catch(err => {
                console.log('err :', err);
                reject(err);
            });
    });
}

function userAnswerFromApiResponse(response) {
    const transcription = response.data.results;

    if (transcription) {
        const userAnswer = transcription.map(
            result => result.alternatives[0].transcript
        );
        console.log(`Transcription: ${userAnswer}`);
        if (userAnswer.toString().substring(0, 1) === 'y') {
            return userResponses.yes;
        } else if (userAnswer.toString().substring(0, 1) === 'n') {
            return userResponses.no;
        } else {
            return userResponses.unclear;
        }
    } else {
        console.log('No results: ', response);
        return userResponses.unclear;
    }
}
